// Долната лента на листа „Прехвърляне": първата пречка пред записа и
// действията — при ново: Изтрий черновата · Запази временно · Прехвърли
// (Ctrl/Cmd+Enter); при редакция: Отказ · Редактирай прехвърляне. Сумите
// (себестойността е нето, брутото — по регистрацията по ДДС) на десктоп са в
// реда „Общо" на решетката; тук — само при карти.
import { useTranslation } from "react-i18next";
import { useInventoryShell } from "../../components/shell/InventoryShellContext";
import { useViewport } from "../../../../hooks/useViewport";
import { KbdChip } from "../../components/KbdChip";
import { PRIMARY_BUTTON_CLASS } from "../../components/list/buttonStyles";
import { DraftFooterActions, type DraftFooterProps } from "../../components/drafts/DraftWorksheetParts";
import { DRAFT_TEXTS } from "../../components/drafts/draftTexts";
import { formatMoney } from "../../components/numbers";

type Props = {
  mode: "new" | "edit";
  totalNet: number;
  totalGross: number;
  issue: string | null;
  // пречката е наличност (червено), не липсващо поле (кехлибарено)
  issueIsStock: boolean;
  // черновата на нов документ (components/drafts/DraftFooterActions)
  draft: DraftFooterProps;
  saving: boolean;
  onCancel: () => void;
  onSave: () => void;
};

export const TransferWorksheetFooter = ({
  mode,
  totalNet,
  totalGross,
  issue,
  issueIsStock,
  saving,
  draft,
  onCancel,
  onSave,
}: Props) => {
  const { t } = useTranslation();
  const { isNarrow } = useInventoryShell();
  const { isDesktop } = useViewport();
  const total = (label: string, value: number, strong = false) => (
    <span className="flex items-baseline gap-[7px]">
      <span className="text-[11px] font-semibold uppercase tracking-[0.1em] text-muted">{label}</span>
      <span
        className={`font-sheet tabular-nums ${
          strong ? "text-xl font-bold text-brand-deep-ink" : "text-[17px] font-semibold text-ink"
        }`}
      >
        {formatMoney(value)}
      </span>
    </span>
  );
  return (
    <footer
      className={`flex shrink-0 flex-wrap items-center border-t border-shade-2 bg-panel ${
        isNarrow
          ? "gap-3 px-3.5 py-3 pb-[calc(12px+env(safe-area-inset-bottom,0px)*0.5)]"
          : "gap-6 px-6 py-3.5"
      }`}
    >
      {!isDesktop && total(t("inventoryPage.colNet"), totalNet)}
      {!isDesktop && total(t("inventoryPage.colGross"), totalGross, true)}
      {issue && (
        <span
          className={`text-[12.5px] font-semibold ${
            issueIsStock ? "text-danger-ink" : "text-brand-deep-ink"
          }`}
        >
          {issue}
        </span>
      )}
      <div className="flex-1" />
      <DraftFooterActions mode={mode} texts={DRAFT_TEXTS.transfer} onCancel={onCancel} {...draft} />
      <button
        type="button"
        onClick={onSave}
        disabled={saving}
        className={`${PRIMARY_BUTTON_CLASS} !px-[22px] !py-3 !text-sm ${issue ? "opacity-55" : ""} ${
          isNarrow ? "flex-[1_1_100%]" : ""
        }`}
      >
        {mode === "edit" ? t("inventoryPage.editSubmitTransfer") : t("inventoryPage.transferSubmit")}
        {!isNarrow && <KbdChip>Ctrl+Enter</KbdChip>}
      </button>
    </footer>
  );
};

export default TransferWorksheetFooter;
